import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/auth.css";
import api from "../api/client.js";
import { useAuth } from "../context/AuthContext.jsx";
import { useI18n } from "../i18n/I18nContext.jsx";

export default function ChangePassword() {
  const { user, updateUser, logout } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  const forced = !!user?.must_change_password;

  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNext, setShowNext] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next.length < 6) {
      setError(t("errorPasswordShort"));
      return;
    }
    if (next !== confirm) {
      setError(t("errorPasswordMatch"));
      return;
    }
    setBusy(true);
    try {
      const res = await api.post("/auth/change-password/", {
        current_password: current,
        new_password: next,
      });
      updateUser(res.data);
      navigate("/");
    } catch (err) {
      const data = err.response?.data;
      setError(
        data?.current_password?.[0] ||
          data?.new_password?.[0] ||
          data?.detail ||
          t("submitError")
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={forced ? "change-password-forced-page" : "page-change-password"} style={forced ? undefined : { maxWidth: 500, margin: "0 auto" }}>
      {!forced && (
        <div className="page-header">
          <h1>{t("changePasswordTitle")}</h1>
        </div>
      )}

      <div className="change-password-card">
        {forced ? (
          <>
            <div className="emblem-wrapper">
              <div className="emblem-icon">
                <i className="ti ti-key"></i>
              </div>
            </div>
            <h2>{t("changePasswordTitle")}</h2>
            <div className="sub">
              {t("forcedSub")}
            </div>
            <div className="demo-box">
              {t("forcedDesc")}
            </div>
          </>
        ) : (
          <div className="sub" style={{ textAlign: "left", marginBottom: 20 }}>
            {t("changePasswordDesc")}
          </div>
        )}

        {error && <div className="error-text">{error}</div>}

        <form onSubmit={submit}>
          <div className="field">
            <label>{t("currentPassword")}</label>
            <div className="password-input-wrapper">
              <input
                type={showCurrent ? "text" : "password"}
                value={current}
                onChange={(e) => setCurrent(e.target.value)}
                placeholder={forced ? user?.mobile : t("currentPasswordPlaceholder")}
                required
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowCurrent(!showCurrent)}
                aria-label={showCurrent ? "Hide password" : "Show password"}
              >
                <i className={showCurrent ? "ti ti-eye-off" : "ti ti-eye"} style={{ fontSize: "16px" }}></i>
              </button>
            </div>
          </div>

          <div className="field">
            <label>{t("newPassword")}</label>
            <div className="password-input-wrapper">
              <input
                type={showNext ? "text" : "password"}
                value={next}
                onChange={(e) => setNext(e.target.value)}
                placeholder={t("newPasswordPlaceholder")}
                required
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowNext(!showNext)}
                aria-label={showNext ? "Hide password" : "Show password"}
              >
                <i className={showNext ? "ti ti-eye-off" : "ti ti-eye"} style={{ fontSize: "16px" }}></i>
              </button>
            </div>
          </div>

          <div className="field">
            <label>{t("confirmNewPassword")}</label>
            <div className="password-input-wrapper">
              <input
                type={showConfirm ? "text" : "password"}
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                placeholder={t("confirmNewPasswordPlaceholder")}
                required
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowConfirm(!showConfirm)}
                aria-label={showConfirm ? "Hide password" : "Show password"}
              >
                <i className={showConfirm ? "ti ti-eye-off" : "ti ti-eye"} style={{ fontSize: "16px" }}></i>
              </button>
            </div>
          </div>

          <div className="change-password-actions">
            <button
              type="button"
              className="btn btn-outline"
              onClick={() => (forced ? logout() : navigate(-1))}
              disabled={busy}
            >
              {forced ? t("signOut") : t("cancel")}
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={busy}
            >
              {busy ? t("saving") : t("savePassword")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
